export default {"src":"/_next/static/media/smiley-life-saver.34c68015.svg","height":96,"width":96};